export const cleanUp = (obj) => {
   const newObj = {};

   Object.keys(obj).length &&  Object.keys(obj).forEach(key => {
       if(obj[key].length) {
           newObj[key] = obj[key]
       }
   })

   return newObj;
}

export const objectToQuery = (obj) => {
    // base query
    let urlQuery = '';

    const newObj = cleanUp(obj);

    Object.keys(newObj).length && Object.keys(newObj).forEach((key, index) => {
        urlQuery += `${index == 0 ? '?' : '&'}${key}=${obj[key]}`
    })

    return urlQuery;
}